import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	portalConfigTabLabel: {
		id: 'portal-settings.portal-tabs.portal-config-tab-label',
		defaultMessage: 'Portal configuration',
		description: 'Title for portal configuration tab',
	},
	portalRequestGroupTabLabel: {
		id: 'portal-settings.portal-tabs.portal-request-group-tab-label',
		defaultMessage: 'Portal groups',
		description: 'Title for portal request group tab',
	},
});
